import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from '@app/core/components/modal/modal.module';
import { TranslateModule } from '@ngx-translate/core';
import { ClassroomUserCardModule } from '../../classroom-user-card';
import { InviteToClassroomModule } from '../../invite-to-classroom/invite-to-classroom.module';
import { ClassroomParticipantCardComponent } from './classroom-participant-card/classroom-participant-card.component';
import { ClassroomParticipantsComponent } from './classroom-participants.component';

@NgModule({
  declarations: [ClassroomParticipantsComponent, ClassroomParticipantCardComponent],
  imports: [CommonModule, TranslateModule, ClassroomUserCardModule, InviteToClassroomModule, ModalModule],
  exports: [ClassroomParticipantsComponent],
})
export class ClassroomParticipantsModule {}
